import React from 'react';
import NumberFormat from 'react-number-format';

export default function DigitFormat(props) {
  const { inputRef, name, onChange, ...other } = props;

  return (
    <NumberFormat
      {...other}
      allowNegative={false}
      getInputRef={inputRef}
      onValueChange={values => onChange({ target: { name: name, value: values.value ? Number(values.value) : null } })}
    />
  )
}
